import React from 'react';
import { useOrganization } from '../contexts/OrganizationContext';

/**
 * Organization Debug Component
 * Shows which organization is loaded (for testing)
 * Remove this in production or hide behind admin flag
 */
const OrganizationDebug = () => {
  const { organization, loading, error } = useOrganization();

  // Don't show in production
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: '#FFF3CD',
        border: '1px solid #FFC107',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 9999
      }}>
        🔄 Loading organization...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: '#F8D7DA',
        border: '1px solid #F5C6CB',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 9999
      }}>
        ❌ Error: {error}
      </div>
    );
  }

  if (!organization) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      background: '#D4EDDA',
      border: '1px solid #C3E6CB',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
        ✅ Organization Loaded
      </div>
      <div><strong>Name:</strong> {organization.name}</div>
      <div><strong>Domain:</strong> {organization.custom_domain}</div>
      <div><strong>ID:</strong> {organization.id.slice(0, 8)}...</div>
    </div>
  );
};

export default OrganizationDebug;
